/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, bitSet, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';
import { SYSTEM_ROLES_BIT_SIZE, SystemRoleBit } from '../profiles';
import { UserSystemRoleIntMapper } from '../users';

import {
  ScheduleTaskChangeDateAfterCompleteType,
  ScheduleTaskTodoEventType,
  ScheduleTaskType,
  ScheduleTemplateDetailsDto,
  ScheduleTemplateListFilter,
  ScheduleTemplateListItemDto,
  ScheduleTemplateStatus,
  ScheduleTemplateTaskDetailsDto,
  ScheduleTemplateTaskListItemDto,
  ScheduleTemplateTaskNoteListItemDto,
  ScheduleTemplateTaskTodoListItemDto,
  ScheduleType,
  TaskRelationDto,
  TaskRelationType,
} from './schedule-template.dto';

export const ScheduleTemplateFilterMapper = entity<ScheduleTemplateListFilter>({
  type: enumeration(ScheduleType),
});

export const ScheduleTemplateListItemMapper = entity<ScheduleTemplateListItemDto>({
  active: enumeration(ScheduleTemplateStatus),
  type: enumeration(ScheduleType),
});

// Schedule Template Mapper
export const ScheduleTemplateDetailsMapper = entity<ScheduleTemplateDetailsDto>({
  active: enumeration(ScheduleTemplateStatus),
  type: enumeration(ScheduleType),
  tasks: arrayOf(subentity<ScheduleTemplateTaskListItemDto>({
    changeDateAfterComplete: enumeration(ScheduleTaskChangeDateAfterCompleteType),
    type: enumeration(ScheduleTaskType),
    notes: arrayOf(subentity<ScheduleTemplateTaskNoteListItemDto>({
      addedDate: date(DateFormat.DateTime),
    })),
    todo: arrayOf(subentity<ScheduleTemplateTaskTodoListItemDto>({
      addedDate: date(DateFormat.DateTime),
      event: enumeration(ScheduleTaskTodoEventType),
      systemRole: UserSystemRoleIntMapper,
    })),
    predecessors: arrayOf(subentity<TaskRelationDto>({
      relation: enumeration(TaskRelationType),
    })),
    startDate: date(DateFormat.DateTime),
    endDate: date(DateFormat.DateTime),
  })),
});

// Schedule Template Task Mapper
export const ScheduleTemplateTaskDetailsMapper = entity<ScheduleTemplateTaskDetailsDto>({
  type: enumeration(ScheduleTaskType),
  changeDateAfterComplete: enumeration(ScheduleTaskChangeDateAfterCompleteType),
  notes: arrayOf(subentity<ScheduleTemplateTaskNoteListItemDto>({
    addedDate: date(DateFormat.DateTime),
  })),
  todo: arrayOf(subentity<ScheduleTemplateTaskTodoListItemDto>({
    addedDate: date(DateFormat.DateTime),
    event: enumeration(ScheduleTaskTodoEventType),
    systemRole: UserSystemRoleIntMapper,
  })),
  predecessors: arrayOf(subentity<TaskRelationDto>({
    relation: enumeration(TaskRelationType),
  })),
});
